/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Enpp.Management <br/>
/// It contains various parts:<br/>
/// 1) a wizard-based selection between the different parts of an enpp configuration
/// 2) most of the parts are based on separate visuals - except the settings and the structures (hls, seu, kpi)
/// 3)
/// <br/>
/// Author: ARF<br />
/// Date: 8.4.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 22.4.2022                                                *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />/// </summary>
$.widget("bluaul.EnppManagement", $.common.VisualBase, {
    vcV: new vcVisual(),
    maxWidthForForms: 930,
    wizard: null,
    wizardStep: 0,
    epid: -1,
    visualType: "",
    dirty: false,
    content: null,
    data: null,
    editId: -1,
    editDataType: 1, //1=hls, 2=seu,3=kpi, 4=settings
    hlsFilterIndex: -1,
    EDIT_DATATYPE_HLS: 1,
    EDIT_DATATYPE_SEU: 2,
    EDIT_DATATYPE_KPI: 3,
    EDIT_DATATYPE_SETTINGS: 4,
    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 330;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);

            ////adopt heights and widths
            var h = parseInt(me.visual.height() - me.fnd("#div-wizard").height());

            me.content = me.fnd("#div-content");
            me.content.height(h - 60);
            //we init the edit dialog
            me._initEditDialog(0.4, 0.4, "enpp-mgmt");
            me._initEditPopup();

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //init event listener
            _VCMQ.addConsumer(me.vcgid);
            _VCMQ.consume(me.visual, me.vcgid, function (event) { me._doEvent(event) });
            //init wizard
            me.wizard = me.fnd("#div-wizard").vcWizard({ 'stepWidth': 153 });

            //init the wizard
            me.element.on("click", "#div-wizard .vc-wizard-step", function () {
                if (!$(this).hasClass("inactive")) {
                    _VCMQ.produce(me.visual, me.vcgid, 'SELECT_ENPP_STEP', $(this));
                }
            });
            me._initWizard();


            //inits all click handler for the edit form
            me.element.on("click", "#div-btn-new", function () {
                if (me.fnd("#div-btn-sort").hasClass("button-toggle-active")) return true;
                //we fill the edit popup
                me.editDialog.find("#div-edit-form").html(me._generateEditForm(-1));
                me.editDialog.dialog("open");
            });

            me.element.on("click", "#div-btn-sort", function () { me._toggleSort(); });

            //click handler for the edit list - we have to get the right id
            me.element.on("click", "#div-content-form .vc-list-item", function (e) {
                if (me.fnd("#div-btn-sort").hasClass("button-toggle-active")) return true;
                var id;
                if ($(e.target).hasClass("vc-list-item")) {
                    id = $(e.target).data("id")
                } else {
                    id = $(e.target).parent(".vc-list-item").data("id")
                }
                //we fill the edit popup
                me.editDialog.find("#div-edit-form").html(me._generateEditForm(id));
                me.editDialog.dialog("open");
            });

            //click handler for the del icon- we have to get the right id
            me.element.on("click", "#div-content-form .vc-list-item .icon-del", function (e) {
                var id;
                if ($(e.target).hasClass("icon-del")) {
                    id = $(e.target).data("id")
                } else {
                    id = $(e.target).parent(".icon-del").data("id")
                }
                me._delEntry(id);
                e.stopPropagation();

            });


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

    _initWizard: function () {
        /// <summary>
        /// This function generates the wizard with the specific wizard steps based on the eventType
        /// </summary>
        var me = this;
        try {
            //first we clear every step
            me.wizard = me.fnd("#div-wizard").vcWizard({ 'stepWidth': 180 });
            for (var i = 0; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                me.wizard.vcWizard({ "clear": i });
            }
            me.fnd("#div-wizard .vc-wizard-step").show();
            me.fnd("#div-wizard").show();

            //reset all selected steps and restart with the entry list 
            me._clearSteps();

            return true;
        } catch (e) {
            me.writeError('_initWizard', e); return false;
        }
    },

    _clearSteps: function () {
        /// <summary>
        /// This function resets everything when we clicked on a tab
        /// </summary>
        var me = this;
        try {

            me.wizardStep = 0;
            me.visualType = "list";
            //we reset all settings
            me.epid = -1;
            me.editDataType = 1;
            me.hlsFilterIndex = -1;
            me.fnd("#div-enpp-name").html("");
            //we will start over - so we will show the entry list 
            me.content.removeClass("hide").hide();
            me.fnd("#div-wizard").removeClass("hide").show();
            me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='list']"));

            return true;
        } catch (e) {
            me.writeError('_clearStep', e); return false;
        }
    },

    _selectStep: function (obj) {
        /// <summary>
        /// This function switches between the  different wizard steps
        /// </summary>
        var me = this;
        var i;
        try {
            me.wizardStep = parseInt(obj.data("step"));
            me.visualType = obj.data("type");
            //set the step to active
            me.wizard.vcWizard("setActive", me.wizardStep);

            //if we select the list wizard step - we reset everything again
            if (me.visualType === "list") {
                me.epid = -1;
                me.editDataType = 1;
                me.hlsFilterIndex = -1;
                me.fnd("#div-event-name").html("");
            } else {
                //otherwise we fetch the data without loading a form (parameter=0)
                //basically we only need it for the entry name
                me._fetchData(0);

            }

            switch (me.epid) {
                case -1: //we selected the list and have to deactivate all wizard steps for one single entry
                    for (i = 1; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                        me.fnd("#div-wizard .vc-wizard-step[data-step='" + i + "']").removeClass("inactive").addClass("inactive");
                    }
                    break;
                case 0: //if we want to add a new entry we have to deactivate all wizard steps except the edit step 
                    me.fnd("#div-wizard .vc-wizard-step[data-type='edit']").removeClass("inactive");
                    for (i = 2; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                        me.fnd("#div-wizard .vc-wizard-step[data-step='" + i + "']").removeClass("inactive").addClass("inactive");
                    }
                    break;
                default:
                    me.fnd("#div-wizard .vc-wizard-step").removeClass("inactive");
            }
            //we load the widgets and form
            me._load();

            return true;
        } catch (e) {
            me.writeError('_selectStep', e); return false;
        }
    },

    _load: function () {
        /// <summary>
        /// This function loads the specific content 
        /// </summary>
        var me = this;
        var h, w, w1;
        var id;
        try {

            me.content.show();

            //we generate a new container
            w = parseInt(me.content.width() - 1);
            h = parseInt(me.content.height());

            me.container = me.getRandomIDContainerObj("div-content-", false);

            me.container.obj.height(h);
            me.container.obj.width(w);
            me.content.html(me.container.obj);
            me.container.obj.html(me.getLoadingIcon());


            switch (me.visualType) {
                case "list": //fetch the event list
                    //we cut the width a bit - if it's too large
                    if (me.container.obj.width() > me.maxWidthForForms) {
                        w1 = me.maxWidthForForms;
                        me.container.obj.width(w1);
                    } else {
                        w1 = me.container.obj.width();
                    }
                    me.fnd("#div-enpp-name").html("");
                    me.vcV.addVisualBaseByName("div-content-", 'VISUAL_FORM_ENPP_EDIT', me.container.random, getCurrentTimestamp(), h, w1, '', '', me.settings.deviceType);
                    break;

                case "edit"://show the event details
                    //we cut the width a bit - if it's too large
                    if (me.container.obj.width() > me.maxWidthForForms) {
                        w1 = me.maxWidthForForms;
                        me.container.obj.width(w1);
                    } else {
                        w1 = me.container.obj.width();
                    }
                    me.vcV.addVisualBaseByName("div-content-", 'VISUAL_FORM_ENPP_EDIT', me.container.random, getCurrentTimestamp(), h, w1, JSON.stringify({ "id": me.epid }), '', me.settings.deviceType);
                    break;

                case "settings"://show the event rule
                    me._fetchData(2);
                    break;

                case "projects"://show the project list
                    me.vcV.addVisualBaseByName("div-content-", 'WIDGET_ASSIGNMENT_LOGGER_ENPP', me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ "id": me.epid, "AssID": me.epid }), '', me.settings.deviceType);
                    break;

                case "structure"://show the structure form
                    me._fetchData(1);
                    break;

                case "signals":// user list
                    me.vcV.addVisualBaseByName("div-content-", 'WIDGET_ASSIGNMENT_SIGNAL_ENPP', me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ "id": me.epid, "AssID": me.epid }), '', me.settings.deviceType);
                    break;

                case "user": //
                    me.vcV.addVisualBaseByName("div-content-", 'WIDGET_ASSIGNMENT_USER_ENPP', me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ "id": me.epid, "AssID": me.epid }), '', me.settings.deviceType);
                    break;
                case "owner": //
                    me.vcV.addVisualBaseByName("div-content-", 'WIDGET_ASSIGNMENT_OWNER_ENPP', me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ "id": me.epid, "AssID": me.epid }), '', me.settings.deviceType);
                    break;
                //case "test":
                //    me.fnd("#div-content").html("nix");
                //    break;

                default: break;
            }

        } catch (e) {
            me.writeError('_load', e);;
        }
    },

    _doEvent: function (event) {
        /// <summary>
        /// Handles differet internal and external events
        /// </summary>
        var me = this;
        try {


            //console.info("got event: " + event.msg);
            // console.info(event.values);

            switch (event.msg) {
                case 'SELECT_ENPP_ID': //gets the selected enpp id form the form.edit and opens the details

                    me.epid = parseInt(event.values.id);
                    me._fetchData(0);
                    me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='edit']"));
                    break;
                case 'SELECT_ENPP_STEP': //switches between the different wizard steps
                    me._selectStep(event.values);
                    break;

                case 'SAVE_ENPPID':

                    //when we get a saved enpp id we just load the first step again and ...
                    me.epid = parseInt(event.values.id);
                    me._fetchData(0);
                    me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='edit']"));
                    break;

                default: break;
            }
        } catch (ex) { me.writeError('doEvent', ex); }
    },

    _fetchData: function (loadType) {
        /// <summary>
        /// This function fetches one existing entry, sets the name in the header
        /// and opens different forms based on the load type
        /// </summary>
        var me = this;
        try {

            me.content.html(me.getLoadingIcon());
            me.getData({ TypeId: 2, ID: me.epid }, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me.data = result;
                me.fnd("#div-enpp-name").html(me.data.Name);


                switch (loadType) {
                    case 0: //do nothing
                        break;
                    case 1: //load structure
                        me._generateDataForm();
                        break;
                    case 2: //load settings
                        me._generateSettingsForm();
                        break;
                    default:
                }

                return true;
            });

        } catch (e) { me.writeError('_fetchData', e); return false; }
        return true;
    },

    _generateSettingsForm: function () {
        /// <summary>
        /// We fill the settings form and init the save button
        /// </summary>
        var me = this;
        var w, h;
        try {

            var div = $("<div>").attr("id", "div-settings");

            div.width(me.maxWidthForForms);
            //col 1 - interval
            var col = $("<div>").addClass("vc-grid-2col vc-grid-margin-bottom").css("float", "left");
            col.append($("<b>").html(me.specific.resources.interval), "<br/>");

            var ddlInterval = $("<select>").attr("id", "ddl-interval").addClass("ddl input  vc-grid-1col vc-grid-margin-bottom");
            ddlInterval.append($("<option>").attr("value", 3).text(me.specific.resources.months));
            ddlInterval.append($("<option>").attr("value", 5).text(me.specific.resources.years));
            col.append(ddlInterval);
            ddlInterval.val(me.data.Settings.IntervalType);

            col.append("<br/>", $("<b>").html(me.specific.resources.comparisonPeriod), "<br/>");
            var ddlPeriods = $("<select>").attr("id", "ddl-comparison-periods").addClass("ddl input");
            for (var i = 0; i < me.specific.MaxComparisonPeriods; i++) {
                ddlPeriods.append($("<option>").attr("value", i).text(i));
            }
            ddlPeriods.val(me.data.Settings.ComparisonPeriods);

            col.append(ddlPeriods, $("<span>").html(" " + me.specific.resources.periods));
            div.append(col);
            //col 2 - baseline
            col = $("<div>").addClass("vc-grid-2col vc-grid-margin-bottom").css("float", "left");

            col.append($("<b>").html(me.specific.resources.baseline));
            col.append("<br/>");
            var ddlBaselineType = $("<select>").attr("id", "ddl-baseline-type").addClass("ddl input  vc-grid-1col vc-grid-margin-bottom");
            ddlBaselineType.append($("<option>").attr("value", 0).text(me.resources.no));
            ddlBaselineType.append($("<option>").attr("value", 1).text(me.specific.resources.global));
            col.append(ddlBaselineType);
            ddlBaselineType.val(me.data.Settings.Baseline.Type);

            var divDateWrapper = $("<div>").attr("id", "div-date-wrapper");
            divDateWrapper.append("<br/>", $("<b>").html(me.specific.resources.timePeriod), "<br/>");

            var divDateBaseline = $("<div>").attr("id", "div-baseline-date").addClass("vc-date");
            divDateWrapper.append(divDateBaseline);

            div.append(col.append(divDateWrapper));


            //col 3 - projects
            col = $("<div>").addClass("vc-grid-2col vc-grid-margin-bottom vc-grid-1col").css("float", "left");
            col.append($("<b>").html(me.specific.resources.projectOverview), "<br/>");
            var ddlProjects = $("<select>").attr("id", "ddl-project-list").addClass("ddl input");
            ddlProjects.append($("<option>").attr("value", 0).text(me.specific.resources.list));
            ddlProjects.append($("<option>").attr("value", 1).text(me.specific.resources.landmap));
            ddlProjects.val(me.data.Settings.ProjectListType);
            col.append(ddlProjects);
            div.append(col.append(ddlProjects));

            div.append($("<div>").css("clear", "both"), "<hr/>");
            div.append($("<div>").attr("id", "div-btn-settings-save").html(me.specific.resources.save).button());

            me.content.html(div);

            ////we init click handler for the logs list
            div.off("click", "#div-btn-settings-save").on("click", "#div-btn-settings-save", function (e) { me._saveSettings(); });
          
            if (me.data.Settings.Baseline.StartDate == "") {
                me.data.Settings.Baseline.StartDate = getCurrentTimestamp();
            }
            ddlInterval.off("change").on("change", function () {
                divDateBaseline.vcDate("destroy").html("");
                divDateBaseline.vcDate({ mode: "Single", align: "center", defaultDate: me.data.Settings.Baseline.StartDate, interval: parseInt($(this).val()), langID: me.UserLangIDForCulture });
            });

            ddlBaselineType.off("change").on("change", function () {
                if (parseInt($(this).val()) == 0) {
                    divDateWrapper.hide();
                } else {
                    divDateWrapper.show();
                }
            });
            if (me.data.Settings.Baseline.Type == 0) divDateWrapper.hide();

            divDateBaseline.vcDate({ mode: "Single", align: "center", defaultDate: me.data.Settings.Baseline.StartDate, interval: me.data.Settings.IntervalType, langID: me.UserLangIDForCulture });


        } catch (e) {
            me.writeError('_generateSettingsForm', e);
            return false;
        }
        return true;
    },

    _saveSettings: function () {
        /// <summary>
        /// This function saves the settings
        /// </summary>
        var me = this;
        try {

            var settings = {};
            var divSettings = me.fnd("#div-settings");

            settings.IntervalType = parseInt(divSettings.find(" #ddl-interval").val());
            settings.ComparisonPeriods = parseInt(divSettings.find(" #ddl-comparison-periods").val());


            var dates = me.fnd("#div-baseline-date").vcDate("getDate");
            
            settings.Baseline = {};
            settings.Baseline.Type = parseInt(divSettings.find(" #ddl-baseline-type").val());
            settings.Baseline.StartDate = dates.from;
            settings.Baseline.EndDate = dates.to;
            settings.ProjectListType = parseInt(divSettings.find(" #ddl-project-list").val());

            me.updateData({ typeid: 1, Epid: me.epid, DataTypId: me.EDIT_DATATYPE_SETTINGS, Settings: settings  }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me.editDialog.dialog("close");
                //we reload the settings form again
                me._fetchData(2);

                return true;
            });

        } catch (e) { me.writeError('saveSettings', e); return false; }
        return true;
    },

    _generateDataForm: function () {
        /// <summary>
        /// This function generates the wrapper for the edit form of the different structures
        ///we add the top menu with the different structure types and the optional hls dropdown
        /// </summary>
        var me = this;
    
        try {
            var form = $("<div>").attr("id", "div-content-form").addClass("vc-list vc-grid-6col");
            var menu = $("<div>").attr("id", "div-content-menu").addClass("vc-grid-margin-bottom");
            menu.append($("<div>").data("type", me.EDIT_DATATYPE_HLS).addClass("data-type button-toggle vc-grid-2col").html(me.specific.resources.areas));
            menu.append($("<div>").data("type", me.EDIT_DATATYPE_SEU).addClass("data-type button-toggle vc-grid-2col").html(me.specific.resources.groups));
            menu.append($("<div>").data("type", me.EDIT_DATATYPE_KPI).addClass("data-type button-toggle vc-grid-2col").html(me.specific.resources.metaTypes));
            menu.append("<hr/>");
            menu.append($("<div>").attr("id", "div-btn-new").addClass("btn vc-grid-margin-bottom").html(me.specific.resources.new));
            menu.append($("<div>").attr("id", "div-btn-sort").addClass("button-toggle vc-grid-2col").html(me.specific.resources.sort));

            //we set the currenttly selected button to active
            menu.find(".data-type").each(function () {
                if ($(this).data("type") == me.editDataType) $(this).addClass("button-toggle-active");
            });

            menu.find(".button-toggle, .btn").button();

            //we init the data type buttons
            menu.find(".data-type").off("click").on("click", function (e) {
                me._toggleDataTypes($(this));
            });

            form.append(menu);
            form.append($("<div>").css("clear", "both"));

            //we add the optional dropdown with hls - it is needed to filter the seus
            var hlsMenu = $("<div>").attr("id", "div-hls-menu").addClass("vc-grid-margin-bottom");
            var hlsDdl = $("<select>").attr("id", "ddl-hls-filter").addClass("input ddl vc-grid-margin-left")
            for (var i = 0; i < me.data.HlsList.length; i++) {
                hlsDdl.append($("<option>").attr("value", me.data.HlsList[i].Id).text(me.data.HlsList[i].Name));
            }
            if (me.hlsFilterIndex > -1) { hlsDdl.prop('selectedIndex', me.hlsFilterIndex); }
            hlsMenu.append($("<span>").html(me.specific.resources.areas + ":"), hlsDdl);
            hlsMenu.find("#ddl-hls-filter").off("change").on("change", function (e) { me._generateDataList(me.editDataType); });
            form.append(hlsMenu);

            //we add a simple list header and the list
            form.append($("<div>").attr("id", "div-content-list-header").addClass("vc-list-header-simple").html(me.specific.resources.name));
            form.append($("<div>").attr("id", "div-content-list").addClass("vc-list-table"));
            me.content.html(form);

            //... and finally load the selected data
            me._toggleDataTypes(me.fnd("#div-content-menu .data-type.button-toggle-active"));

            return true;
        } catch (e) {
            me.writeError('_generateDataForm', e); return false;
        }

    },

    _toggleDataTypes: function (obj) {
        /// <summary>
        /// This function decides which data type we want to open and cleans up stuff 
        /// nothing too complicated
        /// </summary>
        var me = this;
    
        try {

            me.fnd("#div-content-list").html("");

            switch (parseInt(obj.data("type"))) {
                case me.EDIT_DATATYPE_HLS:   //HLS
                    me.editDataType = me.EDIT_DATATYPE_HLS;
                    break;
                case me.EDIT_DATATYPE_SEU:  //SEU
                    me.editDataType = me.EDIT_DATATYPE_SEU;
                    break;

                case me.EDIT_DATATYPE_KPI: //KPI
                    me.editDataType = me.EDIT_DATATYPE_KPI;
                    break;
                default:
            }

          
            me.fnd("#div-content-menu .data-type.button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            //we have to handle/reset te sorting button as well
            me.fnd("#div-btn-sort").removeClass("button-toggle-active").button('option', 'label', me.specific.resources.sort);

            me._generateDataList(me.editDataType);

        } catch (e) {
            me.writeError('_toggleDataTypes', e); return false;
        }

    },

    _generateDataList: function (dataTypeId) {
        /// <summary>
        /// This function generates a list from the selected structure entries
        /// </summary>
        var me = this;
        var item;
        var data;
        var name;
        var bShowDelIcon;
        try {

            var list = me.fnd("#div-content-list").html("");

            //first, we hide the optional hls dropdown
            me.fnd("#div-content-form #div-hls-menu").hide();

            switch (dataTypeId) {
                case me.EDIT_DATATYPE_HLS:   //HLS
                    data = me.data.HlsList;
                    break;
                case me.EDIT_DATATYPE_SEU:  //SEU
                    me.hlsFilterIndex = parseInt(me.fnd("#div-content-form #div-hls-menu #ddl-hls-filter").prop('selectedIndex'));
                    if (me.hlsFilterIndex == -1) {
                        me.fnd("#div-content-form #div-btn-new, #div-content-form #div-btn-sort,#div-content-form  #div-content-list-header").hide();
                        list.html($("<br>"));
                        list.append($("<div>").addClass("error").html(me.specific.resources.pleaseAddHlsAreaFirst));
                        return true;
                    }

                    me.fnd("#div-content-form #div-hls-menu").show();
                    data = me.data.HlsList[me.hlsFilterIndex].SeuList;
                    break;

                case me.EDIT_DATATYPE_KPI: //KPI
                    data = me.data.KpiList;
                    break;
                default:
            }


            if (data.length == 0) {
                list.html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            //now we build the vc-list entries
            for (var i = 0; i < data.length; i++) {
                item = $("<div>", { "class": "vc-list-item" }).data("id", data[i].Id);
                name = data[i].Name;
                //except for seu we add the unit to the name
                if (me.editDataType != me.EDIT_DATATYPE_SEU) {
                    name += " [" + data[i].Unit + "]";

                }

                item.append($("<div>").addClass("vc-list-col vc-list-col-element w75").html(name));
                bShowDelIcon = true;
                if (me.editDataType == me.EDIT_DATATYPE_HLS) {
                    //we cannot delete the entry if the hls has some seu
                    if (data[i].SeuList.length > 0) {
                        bShowDelIcon = false;
                    }
                } else {
                    //we cannot delete the other entries if already signals exist
                    if (data[i].SignalList.length>0) {
                        bShowDelIcon = false;
                    } 
                }

                if (bShowDelIcon) {
                    item.append($("<div>").addClass("icon-del vc-list-col vc-list-col-element w5").css("float", "right").data("id", data[i].Id).html(me.specific.resources.iconDelete));
                } else {
                    item.append($("<div>").addClass("vc-list-col vc-list-col-element w5").html("<br/>"));
                }

                list.append(item);
            }

            list.find('.vc-list-item:even').addClass('alt');

            return true;
        } catch (e) {
            me.writeError('_generateDataList', e); return false;
        }

    },

    _generateEditForm: function (id) {
        /// <summary>
        /// This function generates the hmtl for the edit popup
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item;
        try {

            me.editId = id;
       
            var entry = { Id: -1, Name: "", Bdimsid: -1, ShowSum:true }

            switch (me.editDataType) {
                case me.EDIT_DATATYPE_HLS:   //HLS
                    data = me.data.HlsList;
                    break;
                case me.EDIT_DATATYPE_SEU:  //SEU
                    //we get the seu of the selected hls
                    var hls = me.data.HlsList[parseInt(me.fnd("#div-content-form #div-hls-menu #ddl-hls-filter").prop('selectedIndex'))];
                    data = hls.SeuList;
                    break;

                case me.EDIT_DATATYPE_KPI: //KPI
                    data = me.data.KpiList;
                    break;
                default:
            }

             //we get the selected entry data
            if (id > -1) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].Id == id) { entry = data[i]; }
                }
            }

            var div = $("<div>").html($("<b>").html(me.specific.resources.name));
            div.append("<br/>", $("<input>").attr("id", "txt-name").attr("minlength", "5").attr("required", "required").val(entry.Name).addClass("input txtEnabled"), "<hr/>");
           
            //except for seus we add the unit dropdown
            if (me.editDataType != me.EDIT_DATATYPE_SEU) {
                div.append($("<b>").html(me.specific.resources.dims));
                div.append("<br/>");
                var ddl = $("<select>").attr("id", "ddl-bdimsid").addClass("input ddl")
                for (var i = 0; i < me.specific.DimsList.length; i++) {
                    ddl.append($("<option>").attr("value", me.specific.DimsList[i].Id).text(me.specific.DimsList[i].Name));
                }
                if (entry.Bdimsid > -1) ddl.val(entry.Bdimsid);

                div.append(ddl);
                div.append("<br/>");
            } 
            if (me.editDataType == me.EDIT_DATATYPE_HLS) {
                div.append("<br/>", $("<input>").attr("type", "checkbox").attr("id", "chb-show-sum").prop("checked", entry.ShowSum).addClass("input chb"), " ", $("<b>").html(me.specific.resources.showSumline));
            }
            return div;


        } catch (e) {
            me.writeError('_generateEditForm', e); return "";
        }

    },

    _toggleSort: function () {
        /// <summary>
        /// We toggle between the sort states - if active we make the list sortable otherwise we save the new sorting
        /// </summary>
        var me = this;
        var w, h;
        try {

            if (me.fnd("#div-btn-sort").hasClass("button-toggle-active")) {
                me.fnd("#div-content-list").sortable("destroy");
                me.fnd("#div-btn-sort").removeClass("button-toggle-active").button('option', 'label', me.specific.resources.sort);
                me._sortList();
            } else {

                me.fnd("#div-content-list").sortable({placeholder: 'formSortPlaceholder', forcePlaceholderSize: true, helper: 'clone'}).disableSelection();
                me.fnd("#div-btn-sort").addClass("button-toggle-active").button('option', 'label', me.specific.resources.save);
            }


        } catch (e) {
            me.writeError('_toggleSort', e);
            return false;
        }
        return true;
    },

    _saveEdit: function () {
        /// <summary>
        /// This function saves the structure entries
        /// </summary>
        var me = this;
        try {

            var name = me.editDialog.find(" #txt-name");
            if (name.val().length < 3) {
                name.addClass("invalid");
                return false;
            }

            var entry = { Id: me.editId, Name: me.editDialog.find(" #txt-name").val(), Bdimsid: me.editDialog.find(" #ddl-bdimsid").val() }
            var param = { typeid: 1, Epid: me.epid, DataTypId : me.editDataType }


            //, ShowSum: me.editDialog.find(" #ddl-show-sum").prop("checked")

            switch (me.editDataType) {
                case me.EDIT_DATATYPE_HLS:   //HLS
                    param.hls = entry;
                    param.hls.ShowSum = me.editDialog.find(" #chb-show-sum").prop("checked");
                    break;
                case me.EDIT_DATATYPE_SEU:  //SEU
                    me.hlsFilterIndex = parseInt(me.fnd("#div-content-form #div-hls-menu #ddl-hls-filter").prop('selectedIndex'));
                    param.hls = me.data.HlsList[me.hlsFilterIndex];
                    param.seu = entry;
                    break;

                case me.EDIT_DATATYPE_KPI: //KPI
                    param.kpi = entry;
                    break;
                default:
            }

            //console.info(param);

            me.updateData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me.editDialog.dialog("close");
                me._fetchData(1);

                return true;
            });

        } catch (e) { me.writeError('saveEdit', e); return false; }
        return true;
    },

    _delEntry: function (id) {
        /// <summary>
        /// This function saves everything
        /// </summary>
        var me = this;
        try {

            var hls = { Id: me.editId }
            var param = { typeid: 2, Epid: me.epid, DataTypId: me.editDataType };

            switch (me.editDataType) {
                case me.EDIT_DATATYPE_HLS:   //HLS
                    param.hls = { Id: id };
                    break;
                case me.EDIT_DATATYPE_SEU:  //SEU
                    me.hlsFilterIndex = parseInt(me.fnd("#div-content-form #div-hls-menu #ddl-hls-filter").prop('selectedIndex'));
                    param.hls = me.data.HlsList[me.hlsFilterIndex];
                    param.seu = { Id: id };
                    //data = me.data.SeuList;
                    break;

                case me.EDIT_DATATYPE_KPI: //KPI
                    param.kpi = { Id: id };
                    break;
                default:
            }

            me.updateData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me.editDialog.dialog("close");
                me._fetchData(1);

                return true;
            });

        } catch (e) { me.writeError('delEntry', e); return false; }
        return true;
    },

    _sortList: function () {
        /// <summary>
        /// This function saves a sorted list
        /// </summary>
        var me = this;
        try {

            var lst = [];

            me.fnd("#div-content-list .vc-list-item").each(function (e) {
                lst.push($(this).data("id"));
            });
            var param = { typeid: 3, Epid: me.epid, DataTypId: me.editDataType, SortingList: lst };
            if (me.editDataType == me.EDIT_DATATYPE_SEU) {
                param.hls = me.data.HlsList[parseInt(me.fnd("#div-content-form #div-hls-menu #ddl-hls-filter").prop('selectedIndex'))];
            }

          
            me.updateData(param, function (result) {
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
             
                me._fetchData(1);

                return true;
            });

        } catch (e) { me.writeError('sortList', e); return false; }
        return true;
    },

    _initEditPopup: function () {
        /// <summary>
        /// We init everything we need for the popup form
        /// </summary>
        var me = this;
        var w, h;
        try {

            //we get some height and width
            w = me.editDialog.width - 27;
            h = me.editDialog.height - 100;
            var div = $("<div>").attr("id", "div-edit");
            h -= 5;   //subtract the header

            div.html($("<div>").addClass("vc-list-header-simple vc-grid-margin-bottom").html(me.specific.resources.editData))
            div.append($("<div>").attr("id", "div-edit-form").addClass("vc-grid-margin-bottom"));
            div.append($("<div>").attr("id", "div-btn-edit-save").html(me.specific.resources.save).button());

            div.width(w).height(h);

            me.editDialog.html(div);

            ////we init click handler for the logs list
            div.off("click", "#div-btn-edit-save").on("click", "#div-btn-edit-save", function (e) {  me._saveEdit(); });


        } catch (e) {
            me.writeError('_initEditPopup', e);
            return false;
        }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-wizard, #div-content").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

